import { getSafeInternalRedirectPath } from './getSafeInternalRedirectPath';

const STORAGE_KEY = 'auth.pendingLogoutRedirect';

export const savePendingLogoutRedirect = (path: string | null) => {
  const safePath = getSafeInternalRedirectPath(path);

  if (!safePath) {
    window.sessionStorage.removeItem(STORAGE_KEY);
    return;
  }

  window.sessionStorage.setItem(STORAGE_KEY, safePath);
};
